import { STORE_EXTRA_STEP, CLEAR_EXTRA_STEPS } from '../constants/Constants';

export const extraStepReducer = (state : any = {steps : []}, action) => {
    switch (action.type) {
      case STORE_EXTRA_STEP:
      {
        return {
          ...state,
          steps : state.steps.concat({
            title : action.payload.title
          })
        };
      }        
      case CLEAR_EXTRA_STEPS:
        return {
          steps : []
        };      
      default:
        return state;
    }
};